'use es6';

import PropTypes from 'prop-types';
import Raven from 'raven-js';
import { lazy, PureComponent, Suspense } from 'react';
import { FormattedHTMLMessage } from 'EmailUnsubscribeUI/components/ui/misc/I18n';
import { jsx as _jsx } from "react/jsx-runtime";
const ErrorMessage = /*#__PURE__*/lazy(() => import( /* webpackChunkName: "ui-error-message" */'./ui/misc/ErrorMessage'));
class ErrorBoundary extends PureComponent {
  constructor(...args) {
    super(...args);
    this.state = {
      hasError: false
    };
  }
  static getDerivedStateFromError() {
    return {
      hasError: true
    };
  }
  componentDidCatch(error, errorInfo) {
    Raven.captureException(error, errorInfo);
  }
  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }
    return /*#__PURE__*/_jsx(Suspense, {
      fallback: /*#__PURE__*/_jsx("div", {}),
      children: /*#__PURE__*/_jsx(ErrorMessage, {
        title: /*#__PURE__*/_jsx("span", {}),
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "alerts.FAILED.message"
        })
      })
    });
  }
}
ErrorBoundary.propTypes = {
  children: PropTypes.node
};
export default ErrorBoundary;